// DEPENDENCIES
import React, { useState } from 'react';
// COMPONENTS
import { Link } from 'react-router-dom';
import { Fade } from 'react-awesome-reveal';
// ICONS
import { BsTagFill } from 'react-icons/bs';
import { FaBoxOpen, FaFileInvoiceDollar, FaFileInvoice, FaAward } from 'react-icons/fa';
import { IoRibbonOutline } from 'react-icons/io5';
import { VscFileMedia } from 'react-icons/vsc';
import { IoIosImages } from 'react-icons/io';
import { BiBuildings } from 'react-icons/bi';
import { HiUsers } from 'react-icons/hi';
import { AiFillStar } from 'react-icons/ai';
import { WiStars } from 'react-icons/wi'
// CUSTOM COMPONENTS;
import Section from '../components/Section';
import ContentBlock from '../components/ContentBlock';
import CustomBlock from '../components/CustomBlock';
import ActionStrip from '../components/ActionStrip';
import BottomSheet from '../components/BottomSheet';
import CheckboxBlock from '../components/CheckboxBlock';

import * as Helper from '../helpers/helper';

const DashboardPage = (props) => {
    const role = Helper.LoggedInUserRole();
    const companyId = Helper.LoggedInCompanyId();

    return (
        <>
            <CustomBlock className="main-container light--bg">
                {/* <Fade
                    triggerOnce
                    direction="up"
                    duration={0}
                    delay={0}
                > */}
                <Section>
                    <ContentBlock>
                        <ActionStrip
                            title="Start New Campaign"
                            to="/new-campaign"
                            icon={
                                <FaFileInvoice size={30} color="#FFFFFF" />
                            }
                            iconBgColor="secondary--bg"
                            style={{ marginTop: '5%' }}
                        />
                    </ContentBlock>
                </Section>
                {/* </Fade> */}

                <Section>
                    <ContentBlock cols={6}>
                        {/* <Fade
                            triggerOnce
                            direction="up"
                            duration={600}
                            delay={800}
                            className="w-100"

                        > */}
                        <ActionStrip
                            title="View All Campaigns"
                            to="/campaigns"
                            icon={
                                <FaFileInvoiceDollar size={30} color="#FFFFFF" />
                            }
                            iconBgColor="info--bg"
                        />
                        {/* </Fade> */}
                    </ContentBlock>

                    <ContentBlock cols={6}>
                        {/* <Fade
                            triggerOnce
                            direction="up"
                            duration={600}
                            delay={800}
                            className="w-100"

                        > */}
                        <ActionStrip
                            title="View Media Types"
                            to="/media-types"
                            icon={
                                <VscFileMedia size={30} color="#FFFFFF" />
                            }
                            iconBgColor="primary--bg"
                        />
                        {/* </Fade> */}
                    </ContentBlock>


                    <ContentBlock cols={6}>
                        {/* <Fade
                            triggerOnce
                            direction="up"
                            duration={600}
                            delay={1000}
                            className="w-100"
                        > */}
                        <ActionStrip
                            title="View Categories"
                            to="/categories"
                            icon={
                                <FaBoxOpen size={30} color="#FFFFFF" />
                            }
                            iconBgColor="warning--bg"
                        />
                        {/* </Fade> */}
                    </ContentBlock>

                    <ContentBlock cols={6}>
                        {/* <Fade
                            triggerOnce
                            direction="up"
                            duration={600}
                            delay={1000}
                            className="w-100"

                        > */}
                        <ActionStrip
                            title="View Products"
                            to="/products"
                            icon={
                                <BsTagFill size={30} color="#FFFFFF" />
                            }
                            iconBgColor="danger--bg"
                        />
                        {/* </Fade> */}
                    </ContentBlock>

                    {
                        role == 'SuperAdmin' ?
                            <ContentBlock cols={6}>
                                {/* <Fade
                                    triggerOnce
                                    direction="up"
                                    duration={600}
                                    delay={1200}
                                    className="w-100"

                                > */}
                                <ActionStrip
                                    title="View Companies"
                                    to="/companies"
                                    icon={
                                        <BiBuildings size={30} color="#FFFFFF" />
                                    }
                                    iconBgColor="success--bg"
                                />
                                {/* </Fade> */}

                            </ContentBlock> :
                            <>
                                {
                                    role == 'User' ? <></> :
                                        <ContentBlock cols={6}>
                                            {/* <Fade
                                                triggerOnce
                                                direction="up"
                                                duration={600}
                                                delay={1200}
                                                className="w-100"
                                            > */}
                                            <ActionStrip
                                                title="View Company"
                                                to={"/company/" + companyId}
                                                icon={
                                                    <BiBuildings size={30} color="#FFFFFF" />
                                                }
                                                iconBgColor="success--bg"
                                            />
                                            {/* </Fade> */}
                                        </ContentBlock>
                                }
                            </>
                    }
                    {
                        role != 'User' ?
                            <ContentBlock cols={6}>
                                {/* <Fade
                                    triggerOnce
                                    direction="up"
                                    duration={600}
                                    delay={1200}
                                    className="w-100"
                                > */}
                                <ActionStrip
                                    title="View Users"
                                    to="/users"
                                    icon={
                                        <HiUsers size={30} color="#FFFFFF" />
                                    }
                                    iconBgColor="grey--bg"
                                />
                                {/* </Fade> */}
                            </ContentBlock> : <></>
                    }

                    <ContentBlock cols={12}>
                        {/* <Fade
                            triggerOnce
                            direction="up"
                            duration={600}
                            delay={1400}
                            className="w-100"
                        > */}
                        <ActionStrip
                            title="View Sales Tools"
                            to="/sales-tools"
                            icon={
                                <IoIosImages size={30} color="#FFFFFF" />
                            }
                            iconBgColor="dark-grey--bg"
                        />
                        {/* </Fade> */}

                    </ContentBlock>

                    <ContentBlock cols={12}>
                        {/* <Fade
                            triggerOnce
                            direction="up"
                            duration={600}
                            delay={1400}
                            className="w-100"
                        > */}
                        <ActionStrip
                            title="View Top 20"
                            to="/client-list"
                            icon={
                                <AiFillStar size={30} color="#FFFFFF" />
                            }
                            iconBgColor="warning--bg"
                        />
                        {/* </Fade> */}

                    </ContentBlock>
                </Section>
            </CustomBlock>
        </>
    );
}

export default DashboardPage;